import { render, staticRenderFns } from "./chooseSendTree.vue?vue&type=template&id=2a56413e&"
import script from "./chooseSendTree.vue?vue&type=script&lang=js&"
export * from "./chooseSendTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/flow/chooseSendTree.vue"
export default component.exports